module.exports = "<div :class=uid class=Fragment><div v-show=refreshing class=Fragment__loader><div class=spinner><error-render :uid=uid></error-render></div></div><slot name=content></slot></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/containers/inline.vue
// module id = 412
// module chunks = 0